/**
 * Property-related enums for frontend
 * Note: Most enums are now server-synced via /search/property-options API
 * Use usePropertyOptions hook to get server-synced data instead
 */

// Property category - main deal types
export enum PropertyCategory {
  PRIMARY = "primary",
  BUY = "buy",
  RENT = "rent",
}

// Call status for realtor follow-ups
export enum CallStatus {
  NOT_CALLED = "not_called",
  NO_ANSWER = "no_answer",
  INTERESTED = "interested",
  NOT_INTERESTED = "not_interested",
  WRONG_NUMBER = "wrong_number",
  PENDING = "pending",
}

// Note: ExclusiveType and PublicationStatus moved to server-side
// Use usePropertyOptions().getExclusiveTypes() and getPublicationStatuses() instead

// Property class
export enum PropertyClass {
  ECONOMY = "economy",
  STANDARD = "standard",
  COMFORT = "comfort",
  BUSINESS = "business",
  ELITE = "elite",
}

// Construction status
export enum ConstructionStatus {
  READY = "ready",
  IN_PROGRESS = "in_progress",
  NOT_STARTED = "not_started",
}

// Property condition
export enum Condition {
  REQUIRES_RENOVATION = "requires_renovation",
  FINISHED = "finished",
  FURNISHED = "furnished",
}

// Listing tags
export enum ListingTag {
  EXCLUSIVE = "exclusive",
  HOT = "hot",
  PREMIUM = "premium",
}

// Type definitions for API responses
export interface PropertyOption {
  key: string;
  label: string;
}

export interface PropertyOptionsResponse {
  propertyClasses: PropertyOption[];
  constructionStatuses: PropertyOption[];
  heatingTypes: PropertyOption[];
  wallMaterials: PropertyOption[];
  insulationTypes: PropertyOption[];
  conditions: PropertyOption[];
  renovationTypes: PropertyOption[];
  parkingTypes: PropertyOption[];
  elevatorTypes: PropertyOption[];
  frameTypes: PropertyOption[];
  layoutStatuses: PropertyOption[];
  completionYears: PropertyOption[];
  completionQuarters: PropertyOption[];
  financeOptions: PropertyOption[];
  callStatuses: PropertyOption[];
  listingTags: PropertyOption[];
  exclusiveTypes: PropertyOption[];
  publicationStatuses: PropertyOption[];
}

export enum HiddenContactsEnumEndpoint {
  developer = "developer-contacts",
  owner = "owner-contacts",
}

export enum PublicationStatus {
  DRAFT = "draft",
  PUBLISHED = "published",
  ARCHIVED = "archived",
  PENDING = "pending",
  UNDER_MODERATION = "under_moderation",
}